import { sendToMixpanel } from '../../mixpanel';

const trackAgentCallReveal = () => {
  sendToMixpanel('Reveal Agent Phone', {
    enquiryCTA: `Agency Profile - Our Team`,
  });
};

export default trackAgentCallReveal;
